import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Bell",
  "use": "icon-Bell-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 21\" id=\"icon-Bell\">\n<path fill-rule=\"evenodd\" d=\"M19.094,12.562 L5.299,20.526 C4.756,20.840 4.369,20.654 4.187,20.515 C3.703,20.146 3.526,19.240 3.767,18.360 C3.782,18.305 3.801,18.239 3.824,18.162 C4.092,17.247 4.803,14.818 3.457,12.486 L1.572,9.221 C0.008,6.513 0.893,3.281 3.628,1.702 C6.363,0.123 9.604,0.973 11.168,3.681 L13.053,6.946 C13.646,7.973 14.982,9.362 17.984,10.151 C18.870,10.383 19.568,10.988 19.645,11.589 C19.674,11.816 19.641,12.246 19.094,12.562 ZM15.296,16.610 C16.035,17.890 15.608,19.522 14.341,20.253 C13.075,20.984 11.449,20.539 10.709,19.258 L10.441,18.794 L15.028,16.146 L15.296,16.610 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Bell.svg
// module id = KTCR
// module chunks = 70